/**
 * Where a non-fatal client problem goes.
 *
 * The app has several places where failing loudly would be worse than carrying
 * on — a branding fetch that does not resolve, a tenant list that 404s because
 * its routes are a later phase. Those are correctly *handled*. What they must
 * not be is **invisible**: "do not block the user" and "do not tell anyone,
 * ever" are different decisions, and a swallowed branding failure means a
 * tenant changes their colours, sees nothing happen, and reports the product as
 * broken with nothing in any log to go on (QA defect D4-01).
 *
 * `console.warn`, deliberately, not `console.error`: this is not a failure of
 * the page, and the e2e asserts the console carries no errors on a healthy
 * load. Phase 08 can route this to a real sink; the seam is the point.
 */
export function reportProblem(scope: string, detail: unknown): void {
  const message = detail instanceof Error ? detail.message : String(detail);
  // eslint-disable-next-line no-console
  console.warn(`[${scope}] ${message}`);
}
